var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/edit-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.25 13.2366H1.75C1.51083 13.2366 1.3125 13.0383 1.3125 12.7991C1.3125 12.56 1.51083 12.3616 1.75 12.3616H12.25C12.4892 12.3616 12.6875 12.56 12.6875 12.7991C12.6875 13.0383 12.4892 13.2366 12.25 13.2366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.0948 2.43333C9.96317 1.30166 8.85484 1.2725 7.69401 2.43333L6.98817 3.13916C6.92984 3.1975 6.90651 3.29083 6.92984 3.3725C7.37317 4.91833 8.60984 6.155 10.1557 6.59833C10.179 6.60416 10.2023 6.61 10.2257 6.61C10.2898 6.61 10.3482 6.58666 10.3948 6.54L11.0948 5.83416C11.6723 5.2625 11.9523 4.70833 11.9523 4.14833C11.9582 3.57083 11.6782 3.01083 11.0948 2.43333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.10586 7.12916C8.93669 7.0475 8.77336 6.96583 8.61586 6.8725C8.48752 6.79666 8.36502 6.715 8.24252 6.6275C8.14336 6.56333 8.02669 6.47 7.91586 6.37666C7.90419 6.37083 7.86336 6.33583 7.81669 6.28916C7.62419 6.12583 7.40836 5.91583 7.21586 5.6825C7.19836 5.67083 7.16919 5.63 7.12836 5.5775C7.07002 5.5075 6.97086 5.39083 6.88336 5.25666C6.81336 5.16916 6.73169 5.04083 6.65586 4.9125C6.56252 4.755 6.48086 4.59749 6.39919 4.43416C6.29211 4.20471 5.99097 4.13655 5.81192 4.31559L2.53169 7.59583C2.45586 7.67166 2.38586 7.8175 2.36836 7.91666L2.05336 10.1508C1.99502 10.5475 2.10586 10.9208 2.35086 11.1717C2.56086 11.3758 2.85252 11.4867 3.16752 11.4867C3.23752 11.4867 3.30752 11.4808 3.37752 11.4692L5.61752 11.1542C5.72252 11.1367 5.86836 11.0667 5.93836 10.9908L9.224 7.70518C9.39947 7.52972 9.33354 7.22782 9.10586 7.12916Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.7648bfcc13dec3d83afe2567229179b1.svg";
export { ForwardRef as ReactComponent };